import { defineComponent as _defineComponent } from 'vue'
import {
	convertToHumanAmount,
	convertToHumanNumber,
	DEFAULT_PER_PAGE,
	formatPrice,
	HoldersDTO,
	IHolders,
	IPaginateEventParams,
} from "@/shared";
import { ref, onMounted } from "vue";
import TableResponsive from "@/components/common/TableResponsive.vue";
import Pagination from "@/components/common/Pagination.vue";
import AccountAddress from "@/components/common/AccountAddress.vue";
import Spinner from "../common/Spinner.vue";
import fetchWithAuth from "@/plugins/fetch";

// props
interface IProps {
	mint: string;
	decimals: number;
	currentPrice: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TokenHolders',
  props: {
    mint: null,
    decimals: null,
    currentPrice: null
  },
  setup(__props: any) {

const props = __props as {
	mint: string;
	decimals: number;
	currentPrice: number;
};



// data
const loading = ref<boolean>(false);
const holders = ref<IHolders | null>(null);
const count = ref<number>(0);
const price = ref<number>(0);

// methods
function mounted() {
	price.value = props.currentPrice;
	getHoldersCount(props.mint);
	getHolders({
		mint: props.mint,
		page: 0,
		limit: DEFAULT_PER_PAGE,
	});
}
async function getHoldersCount(mint: string): Promise<void> {
	const primitive = await fetchWithAuth(`https://data.fluxbeam.xyz/tokens/${mint}/holders/count`);

	if (!primitive) return;

	count.value = Number(primitive.count);
}

async function getHolders({
	mint,
	page,
	limit,
}: {
	mint: string;
	page: number;
	limit: number;
}): Promise<void> {
	loading.value = true;
	// holders.value = null;

	const params = new URLSearchParams();
	params.append("page", page.toString());
	params.append("limit", limit.toString());
	params.append("all", "false");

	const primitive = await fetchWithAuth(
		`https://data.fluxbeam.xyz/tokens/${mint}/traders?${params.toString()}`
	);

	holders.value = HoldersDTO(primitive);
	loading.value = false;
}
async function paginate({
	page,
	perPage,
}: IPaginateEventParams): Promise<void> {
	getHolders({
		mint: props.mint,
		page: page,
		limit: perPage,
	});
}

// setup
onMounted(mounted);

return { __sfc: true,props, loading, holders, count, price, mounted, getHoldersCount, getHolders, paginate, convertToHumanAmount, convertToHumanNumber, formatPrice, TableResponsive, Pagination, AccountAddress, Spinner }
}

})